declare var jQuery: any;

// Read the `min` attribute WITHOUT the `parseInt(...) || 1` trap: a legitimate
// min="0" (grouped / membership-grouped product children, cart rows) is falsy
// in JS and would otherwise collapse to 1. Only fall back to 1 when the
// attribute is genuinely absent or non-numeric.
const getMinValue = ($input: any): number => {
    const min = parseInt($input.attr('min'), 10);
    return isNaN(min) ? 1 : min;
};

// An input is "optional" when its min is 0 or less and it is currently blank.
// Grouped product children render this way so the customer can leave a row
// empty to skip that item — we must never force a value into it.
const isOptionalBlank = ($input: any, min: number): boolean => {
    const raw = $input.val();
    return min <= 0 && (raw === '' || raw === null || raw === undefined || isNaN(parseInt(raw, 10)));
};

const clampQuantityInput = ($input: any): void => {
    const min = getMinValue($input);

    // Leave optional/skippable rows untouched.
    if (isOptionalBlank($input, min)) {
        return;
    }

    const maxAttr = $input.attr('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : 0;
    const val = parseInt($input.val(), 10);

    if (isNaN(val) || val < min) {
        $input.val(min);
        return;
    }

    if (max > 0 && val > max) {
        $input.val(max);
    }
};

const initQuantityInputs = (context?: string | Document | Element): void => {
    const $scope = context ? jQuery(context) : jQuery(document);
    $scope.find('.quantity input.qty').each(function (this: HTMLElement) {
        clampQuantityInput(jQuery(this));
    });
};

const getQuantityInputFromControl = ($control: any): any => {
    const $quantity = $control.closest('.quantity');
    if ($quantity.length) {
        return $quantity.find('input.qty');
    }
    return $control.siblings('input.qty');
};

jQuery(document).ready(() => {
    initQuantityInputs();

    jQuery(document).on('change input blur', '.quantity input.qty', function (this: HTMLElement) {
        clampQuantityInput(jQuery(this));
    });

    jQuery(document).on('keydown', '.quantity input.qty', function (this: HTMLElement, e: KeyboardEvent) {
        const $input = jQuery(this);
        const min = getMinValue($input);

        // Never coerce an optional/skippable row via the keyboard either.
        if (isOptionalBlank($input, min)) {
            return;
        }

        const val = parseInt($input.val(), 10) || min;

        if (e.key === 'ArrowDown' && val <= min) {
            e.preventDefault();
            $input.val(min);
        }
    });

    jQuery(document).on('click', '.quantity .minus, .quantity .qty-minus, .quantity button.minus', function (this: HTMLElement, e: Event) {
        const $input = getQuantityInputFromControl(jQuery(this));
        if (!$input.length) {
            return;
        }

        const min = getMinValue($input);

        if (isOptionalBlank($input, min)) {
            return;
        }

        const val = parseInt($input.val(), 10) || min;

        if (val <= min) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $input.val(min);
            return false;
        }
    });

    jQuery(document).on('found_variation', 'form.cart', function (_e: any, variation: any) {
        const $qty = jQuery(this).find('.quantity input.qty');

        if (variation.min_qty) {
            $qty.attr('min', variation.min_qty);
        }

        clampQuantityInput($qty);
    });

    jQuery(document.body).on('updated_cart_totals updated_wc_div', () => {
        initQuantityInputs();
    });

    jQuery(document).on('click', '.load-add-to-cart', () => {
        setTimeout(() => initQuantityInputs('#addToCartSideNav'), 300);
    });
});
